import {
    SHOW_DEFAULT_HOME_PAGE_BOT, HIDE_ASSISTATNT_BOT, HIDE_CHATWIDGET,
    OPEN_ASSISTATNT_BOT, SHOW_CHATWIDGET, HIDE_DEFAULT_HOME_PAGE_BOT,
    SET_INITIALIZE_DEFAULT_HOMEPAGE_BOT,
    SET_CLEAR_CACHE_FOR_SPINNET_BOT
} from "../constants";


export const setOpenAssistantBot = () => {
    return {
        type: OPEN_ASSISTATNT_BOT,
    };
};

export const setCloseAssistantBot = () => {
    return {
        type: HIDE_ASSISTATNT_BOT,
    };
};

export const setInitializeDefaultHomePageBot = () => {
    return {
        type: SET_INITIALIZE_DEFAULT_HOMEPAGE_BOT,
    }
};

export const setShowDefaultHomepageBot = () => {
    return {
        type: SHOW_DEFAULT_HOME_PAGE_BOT,
    }
};

export const setHideDefaultHomepageBot = () => {
    return {
        type: HIDE_DEFAULT_HOME_PAGE_BOT,
    }
};

export const setShowChatwidget = () => {
    return {
        type: SHOW_CHATWIDGET,
    }
};


export const setHideChatwidget = () => {
    return {
        type: HIDE_CHATWIDGET,
    }
};

//first time clear cache for spinnet bot when user login 
export const setClearCacheForSpinnetBot = (data) => {
    return {
        type: SET_CLEAR_CACHE_FOR_SPINNET_BOT,
        payload : data
    }
};